<template>
  <div :class="[!color ? 'bg-light' : userIsAParent ? 'bg-main' : 'bg-main2'] +' '+ customClass">
    <section
      class="d-flex text-center px-3 py-2"
      :class="[color ? 'text-light' : 'text-dark']"
    >
      <b-link
        class="material-icons align-middle"
        :class="[color ? 'text-light' : 'text-dark']"
      @click="$router.go(-1)"

      >
        arrow_back
      </b-link>
      <p class="text-uppercase w-100">
        {{ title }}
      </p>
    </section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    color: Boolean,
    title: String,
    customClass: String
  },
  computed: {
    ...mapGetters("user", ["userIsAParent"])
  }
};
</script>
